import { createStructuredSelector } from 'reselect';

import { getModal } from 'shared/store/app/selectors';

const selector = createStructuredSelector({ modal: getModal });

export { selector as default };
